import { render, staticRenderFns } from "./ReleasesFilter.vue?vue&type=template&id=3d167140"
import script from "./ReleasesFilter.vue?vue&type=script&lang=ts"
export * from "./ReleasesFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports